import { enableStaticRendering } from 'mobx-react-lite';
import RootStore, { RootStoreProps } from './RootStore';

const isServer = typeof window === 'undefined';
enableStaticRendering(isServer);
export let rootStore: RootStore = new RootStore();

const initializeRootStore = (initialData?: RootStoreProps): RootStore => {
    const _store = rootStore ?? new RootStore();
    if (initialData) {
        _store.hydrate(initialData);
    }

    if (typeof window === 'undefined') return _store;

    if (!rootStore) {
        rootStore = _store;
    }

    return _store;
};
export default initializeRootStore;
